<template>
    <div class="row">
        <div class="col-12 active">
            <div class="card active">
                <div class="card-body mini-nav bg-primary pt-2 pb-3 active">
                    <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">
                        <button
                                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                                aria-label="Toggle navigation">
                            <span class="mdi mdi-menu"></span>
                        </button>
                        <div class="collapse navbar-collapse justify-content-between active"
                             id="navbarNavAltMarkup">

                            <div class="navbar-nav">
<!--                                <router-link  :to="{name: 'stats-bulk'}" active-class="mm-active" class="nav-item nav-link">STATS</router-link>-->
                                <router-link  :to="{name: 'new-register'}" active-class="mm-active" class="nav-item nav-link">NEW REGISTER</router-link>
                                <router-link  :to="{name: 'pending-records'}" active-class="mm-active" class="nav-item nav-link">PENDING RECORDS</router-link>
                                <router-link  :to="{name: 'pending-downgrade'}" active-class="mm-active" class="nav-item nav-link">PENDING UP/DOWNGRADE</router-link>
                                <router-link  :to="{name: 'approved-downgrade'}" active-class="mm-active" class="nav-item nav-link">APPROVED UP/DOWNGRADE</router-link>
                                <router-link  :to="{name: 'rejected-downgrade'}" active-class="mm-active" class="nav-item nav-link">REJECTED UP/DOWNGRADE</router-link>
                                <router-link  :to="{name: 'archived'}" active-class="mm-active" class="nav-item nav-link">ARCHIVED RECORDS</router-link>
                                <router-link  :to="{name: 'previous-register'}" active-class="mm-active" class="nav-item nav-link">PREVIOUS REGISTER</router-link>
                                <router-link  :to="{name: 'bulk-invoicer'}" active-class="mm-active" class="nav-item nav-link">BULK INVOICER</router-link>
                            </div>

                        </div>
                    </nav>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {getRight} from "@/api";

    export default {
        name: "ToolBar",
        data() {
            return {
                dashboard: true,
                validation: true,
                inspection: true,
                approval: true,
                declined: true,
                approved: true,
                paidSbp: true,
                unpaidSbp: true,
                unpaidBills: true,
                sbpPaidBills: true,
                sbpMap: true,
                selectedSub: null,
            }
            },
        methods:{
            getRight(type){
                return getRight(type)
            },
            mounted() {

                this.selectedSub = sessionStorage.getItem("selectedSub")

            },
            gotTo(route){
                this.$router.push(route);
                sessionStorage.setItem("selectedSub",route)
                this.selectedSub = route
            }
        }
    }
</script>

<style scoped>

</style>